export interface PostUpdateFavouriteRequest {
    RuleId: string;
    Action: string; // add or remove
}

export enum FavouriteActionType {
    Add = "add",
    Delete = "remove"
}
